import { listKeycards } from './index';

import { keycardsRouteStore } from '../domain/store';

export default (number) => {
  keycardsRouteStore.setValue('currentPage', number);
  return listKeycards();
};
